<template>
	<div class="flex xs-12 wrap">
		<div class="flex wrap xs-12 min-height mb3">
			<div class="flex xs-12 md-6 xs-left xs-bottom ml2">
				<h2 class="fs7 lh125 fw7 c1 mr4">
					<j-button
						size="small"
						class="mr2"
						type="secondary"
						@click="$emit('showProposalList')"
					>
						<crm-icon name="back" size="normal" color="c5" class="mr1" />
					</j-button>
					{{ currentProposalName }}
				</h2>
			</div>
		</div>
		<div class="flex xs-12 bt1 bc7">
			<div class="flex wrap xs-12">
				<!-- LEFT: Steps -->
				<div class="xs-12 md-2 bg5 br1 bc7">
					<aeg-steps :tree="steps" @node:select="selectStep"></aeg-steps>
				</div>

				<!-- MIDDLE: Current Step -->
				<div class="xs-12 md-7 p8">
					<component :is="componentToDisplay" v-bind="currentStepProps" />
				</div>

				<!-- RIGHT: notes files, actions -->
				<div class="xs-12 md-3 bc7 bl1 bg5 p4">
					<case-notes-card class="mt6" />
					<case-files-card class="mt6" />
					<proposals-generated-policies class="mt6" />
					<case-actions
						class="mt6"
						:actions="[{ name: 'Get PDF File', value: 'ActionGetPdfFile' }]"
					/>
				</div>
			</div>
			<div
				class="xs-12 p1 ta3 bg4"
				style="position:fixed; bottom:0; right: 0; z-index:100;"
				@click="
					$store.commit(
						'caseManagement/SET_GOD_MODE',
						!$store.state.caseManagement.isGodMode
					)
				"
			>
				<span class="tt2 fs2 c6 fw7 cu2">
					God Mode is
					{{ $store.state.caseManagement.isGodMode == true ? "On" : "Off" }}
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import JButton from "@/components/JButton"
// CMS
import CaseFilesCard from "../CaseFilesCard"
import CaseNotesCard from "../CaseNotesCard"
import CaseActions from "../CaseActions/CaseActions.vue"
import ProposalsGeneratedPolicies from "../ProposalsGeneratedPolicies.vue"
import AegSteps from "../AegSteps.vue"
import AegTabs from "../AegTabs.vue"

import JBProposalOverview from "./JBProposalOverview"
import JBProposalPolicyholder from "./JBProposalPolicyholder"
import JBProposalInsureds from "./JBProposalInsureds"
import JBProposalBusinessNature from "./JBProposalBusinessNature"
import JBProposalEmployees from "./JBProposalEmployees"
import JBProposalStockValues from "./JBProposalStockValues"
import JBProposalSafeValues from "./JBProposalSafeValues"
import JBProposalWindowsDisplay from "./JBProposalWindowsDisplay"
import JBProposalOutdoorRisk from "./JBProposalOutdoorRisk"
import JBProposalHomeRisk from "./JBProposalHomeRisk"
import JBProposalEntrustments from "./JBProposalEntrustments"
import JBProposalSendings from "./JBProposalSendings"
import JBProposalExihibitionsDisplays from "./JBProposalExihibitionsDisplays"
import JBProposalOutsideLimit from "./JBProposalOutsideLimit"
import JBProposalPremisesGeneralProtection from "./JBProposalPremisesGeneralProtection"
import JBProposalDisplayWindowAndShowcase from "./JBProposalDisplayWindowAndShowcase"
import JBProposalBurglarAlarms from "./JBProposalBurglarAlarms"
import JBProposalSafes from "./JBProposalSafes"
import JBProposalStrongRoom from "./JBProposalStrongRoom"
import JBProposalKeysAndSpecialProtectionMeans from "./JBProposalKeysAndSpecialProtectionMeans"
import JBProposalStockRecords from "./JBProposalStockRecords"
import JBProposalLosses from "./JBProposalLosses"
import JBProposalReceipts from "./JBProposalReceipts"
import JBProposalContentsFireRate from "./JBProposalContentsFireRate"
import JBProposalSumInsured from "./JBProposalSumInsured"
import JBProposalReferences from "./JBProposalReferences"
import JBProposalOtherInsurance from "./JBProposalOtherInsurance"
import JBProposalMaterialFacts from "./JBProposalMaterialFacts"

import AegCaseAddOffer from "../AegCaseAddOffer"

export default {
	components: {
		CrmIcon,
		JButton,
		// Should come from CMS
		CaseFilesCard,
		CaseNotesCard,
		CaseActions,
		ProposalsGeneratedPolicies,
		AegSteps,
		AegTabs,

		JBProposalOverview,
		JBProposalPolicyholder,
		JBProposalInsureds,
		JBProposalBusinessNature,
		JBProposalEmployees,
		JBProposalStockValues,
		JBProposalSafeValues,
		JBProposalWindowsDisplay,
		JBProposalOutdoorRisk,
		JBProposalHomeRisk,
		JBProposalEntrustments,
		JBProposalSendings,
		JBProposalExihibitionsDisplays,
		JBProposalOutsideLimit,
		JBProposalPremisesGeneralProtection,
		JBProposalDisplayWindowAndShowcase,
		JBProposalBurglarAlarms,
		JBProposalSafes,
		JBProposalStrongRoom,
		JBProposalKeysAndSpecialProtectionMeans,
		JBProposalStockRecords,
		JBProposalLosses,
		JBProposalReceipts,
		JBProposalContentsFireRate,
		JBProposalSumInsured,
		JBProposalReferences,
		JBProposalOtherInsurance,
		JBProposalMaterialFacts,

		AegCaseAddOffer
	},
	data() {
		return {
			step: "",
			// Steps
			steps: [
				{
					id: "JBProposalOverview",
					component: "JBProposalOverview",
					title: "Overview"
				},
				{
					id: "JBProposalPolicyholder",
					component: "JBProposalPolicyholder",
					title: "Policyholder"
				},
				{
					id: "JBProposalInsureds",
					component: "JBProposalInsureds",
					title: "Insured"
				},
				{
					id: "JBProposalBusinessNature",
					component: "JBProposalBusinessNature",
					title: "Business Nature"
				},
				{
					id: "JBProposalEmployees",
					title: "Employees",
					component: "JBProposalEmployees"
				},
				{
					id: "JBProposalStockValues",
					title: "Stock Values",
					component: "JBProposalStockValues"
				},
				{
					id: "JBProposalSafeValues",
					title: "Values Out of Safe",
					component: "JBProposalSafeValues"
				},
				{
					id: "JBProposalWindowsDisplay",
					title: "Windows Display",
					component: "JBProposalWindowsDisplay"
				},
				{
					id: "JBProposalOutdoorRisk",
					title: "Outdoor Risk",
					component: "JBProposalOutdoorRisk"
				},
				{
					id: "JBProposalHomeRisk",
					title: "Home Risk",
					component: "JBProposalHomeRisk"
				},
				{
					id: "JBProposalEntrustments",
					title: "Entrustments",
					component: "JBProposalEntrustments"
				},
				{
					id: "JBProposalSendings",
					title: "Sendings",
					component: "JBProposalSendings"
				},
				{
					id: "JBProposalExihibitionsDisplays",
					title: "Exihibitions and Displays",
					component: "JBProposalExihibitionsDisplays"
				},
				{
					id: "JBProposalOutsideLimit",
					title: "Outside Limit",
					component: "JBProposalOutsideLimit"
				},
				{
					id: "JBProposalPremisesGeneralProtection",
					title: "Premises General Protection",
					component: "JBProposalPremisesGeneralProtection"
				},
				{
					id: "JBProposalDisplayWindowAndShowcase",
					title: "Display Window and Showcase Protections",
					component: "JBProposalDisplayWindowAndShowcase"
				},
				{
					id: "JBProposalBurglarAlarms",
					title: "Burglar Alarms",
					component: "JBProposalBurglarAlarms"
				},
				{
					id: "JBProposalSafes",
					title: "Safes",
					component: "JBProposalSafes"
				},
				{
					id: "JBProposalStrongRoom",
					title: "Strong Room",
					component: "JBProposalStrongRoom"
				},
				{
					id: "JBProposalKeysAndSpecialProtectionMeans",
					title: "Keys and Special Means of Protection",
					component: "JBProposalKeysAndSpecialProtectionMeans"
				},
				{
					id: "JBProposalStockRecords",
					title: "Stock Records",
					component: "JBProposalStockRecords"
				},
				{
					id: "JBProposalLosses",
					title: "Losses",
					component: "JBProposalLosses"
				},
				{
					id: "JBProposalReceipts",
					title: "Receipts",
					component: "JBProposalReceipts"
				},
				{
					id: "JBProposalContentsFireRate",
					title: "Contents Fire Rate",
					component: "JBProposalContentsFireRate"
				},
				{
					id: "JBProposalSumInsured",
					title: "Sum Insured",
					component: "JBProposalSumInsured"
				},
				{
					id: "JBProposalReferences",
					title: "References",
					component: "JBProposalReferences"
				},
				{
					id: "JBProposalOtherInsurance",
					title: "Other Insurance",
					component: "JBProposalOtherInsurance"
				},
				{
					id: "JBProposalMaterialFacts",
					title: "Other Material Facts",
					component: "JBProposalMaterialFacts"
				},
				{
					id: "AegCaseAddOffer1",
					component: "AegCaseAddOffer",
					title: "Rating & Clauses - Primary Layer",
					props: {
						productIdOptions: [
							{
								type: "jewellers_block",
								plan: "jewellers_block_primary_layer_hkd",
								version: null
							},
							{
								type: "jewellers_block",
								plan: "jewellers_block_primary_layer_usd",
								version: null
							}
						],
						componentToRender: "JBOffers"
					}
				},
				{
					id: "AegCaseAddOffer2",
					component: "AegCaseAddOffer",
					title: "Rating & Clauses - Excess Layer",
					props: {
						productIdOptions: [
							{
								type: "jewellers_block",
								plan: "jewellers_block_excess_layer_hkd",
								version: null
							},
							{
								type: "jewellers_block",
								plan: "jewellers_block_excess_layer_usd",
								version: null
							}
						],
						componentToRender: "JBOffers"
					}
				},
				{
					id: "AegCaseAddOffer3",
					component: "AegCaseAddOffer",
					title: "Rating & Clauses - Open Market",
					props: {
						productIdOptions: [
							{
								type: "jewellers_block",
								plan: "jewellers_block_open_market_hkd",
								version: null
							},
							{
								type: "jewellers_block",
								plan: "jewellers_block_open_market_usd",
								version: null
							}
						],
						componentToRender: "JBOffers"
					}
				}
			]
		}
	},
	computed: {
		currentProposalName() {
			return (
				this.$store.state.caseManagement.proposals.find(
					proposal =>
						proposal.id === this.$store.state.caseManagement.proposalId
				)?.name || "Unnamed Proposal"
			)
		},

		currentStepProps() {
			return this.steps?.find(item => item.id === this.step)?.props
		},

		componentToDisplay() {
			return this.steps?.find(item => item.id === this.step)?.component
		}
	},
	methods: {
		selectStep(stepToSelect) {
			// Select tab
			this.step = stepToSelect.id

			// Change selected tab
			this.steps = this.steps.map(step => ({
				...step,
				isSelected: stepToSelect.id === step.id ? true : false
			}))
		}
	},

	created() {
		this.selectStep({ id: "JBProposalOverview" })
	}
}
</script>

<style></style>
